export const editorStyles = {
	'& .ProseMirror': {
		outline: 'none',
		minHeight: '100px',
		wordBreak: 'break-word',
		overflowWrap: 'break-word',
		'&:focus': {
			outline: 'none',
		},
	},
	// Content styles - scope to ProseMirror direct children only
	// Custom node views (like topic-node) handle their own content styling
	'& .ProseMirror > p': {
		color: 'text.softer',
		fontSize: '1rem',
		lineHeight: '1.5rem',
		paddingBottom: 3,
		marginBottom: 0,
	},
	'& .ProseMirror > ul p, & .ProseMirror > ol p': {
		paddingBottom: '0',
		lineHeight: '1.5rem',
	},
	'& .ProseMirror > h1': {
		fontSize: '2xl',
		fontWeight: 'bold',
		marginTop: 4,
		marginBottom: 2,
	},
	'& .ProseMirror > h2': {
		fontSize: 'xl',
		fontWeight: 'semibold',
		marginTop: 3,
		marginBottom: 2,
	},
	'& .ProseMirror > h3': {
		fontSize: 'lg',
		fontWeight: 'semibold',
		marginTop: 2,
		marginBottom: 1,
	},
	'& .ProseMirror > ul, & .ProseMirror > ol': {
		paddingLeft: 6,
		marginBottom: 2,
	},
	'& .ProseMirror > ul li, & .ProseMirror > ol li': {
		marginBottom: 1,
	},
	'& .ProseMirror > blockquote': {
		borderLeft: '4px solid',
		borderColor: 'border.default',
		paddingLeft: 4,
		marginY: 2,
		color: 'text.softer',
		fontStyle: 'italic',
	},
	'& .ProseMirror code': {
		bg: 'bg.subtle',
		px: 1,
		py: 0.5,
		borderRadius: 'sm',
		fontSize: 'sm',
		fontFamily: 'mono',
	},
	'& .ProseMirror > pre': {
		bg: 'bg.subtle',
		p: 3,
		borderRadius: 'md',
		overflow: 'auto',
		marginY: 2,
	},
	'& .ProseMirror img': {
		maxW: 'full',
		borderRadius: 'md',
		marginY: 2,
	},
	'& .ProseMirror p.is-editor-empty:first-of-type::before': {
		color: 'text.softest',
		content: 'attr(data-placeholder)',
		float: 'left',
		height: 0,
		pointerEvents: 'none',
	},
	'& .collaboration-cursor__caret': {
		borderLeft: '2px solid',
		borderColor: 'currentColor',
		marginLeft: '-1px',
		marginRight: '-1px',
		pointerEvents: 'none',
		position: 'relative',
		wordBreak: 'normal',
	},
	'& .collaboration-cursor__label': {
		borderRadius: 'sm',
		color: 'white',
		fontSize: 'xs',
		fontWeight: 'semibold',
		left: '-1px',
		lineHeight: 'none',
		padding: '2px 6px',
		position: 'absolute',
		top: '-1.6em',
		userSelect: 'none',
		whiteSpace: 'nowrap',
		boxShadow: 'sm',
	},
} as const;
